module.exports = __webpack_public_path__ + "static/OA-243bf95823d9637d3cb0a36a4b8936d6.png";